export var StaffApiEndpoint;
(function (StaffApiEndpoint) {
    StaffApiEndpoint["Archive"] = "archive/";
    StaffApiEndpoint["CreateUser"] = "create/";
    StaffApiEndpoint["GetAllStaff"] = "";
    StaffApiEndpoint["GetById"] = "";
    StaffApiEndpoint["GetOverview"] = "overview/";
})(StaffApiEndpoint || (StaffApiEndpoint = {}));
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoic3RhZmYuYXBpLWVuZHBvaW50LmpzIiwic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsic3RhZmYuYXBpLWVuZHBvaW50LnRzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiJBQUFBLE1BQU0sQ0FBTixJQUFZLGdCQU1YO0FBTkQsV0FBWSxnQkFBZ0I7SUFDeEIsd0NBQW9CLENBQUE7SUFDcEIsMENBQXNCLENBQUE7SUFDdEIsb0NBQWdCLENBQUE7SUFDaEIsZ0NBQVksQ0FBQTtJQUNaLDZDQUF5QixDQUFBO0FBQzdCLENBQUMsRUFOVyxnQkFBZ0IsS0FBaEIsZ0JBQWdCLFFBTTNCIn0=